import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const CHAPTERS = [
  {
    number: "01",
    title: "Packs Flat",
    body: "Everything we sell answers one question first: where does it go when you're not using it? If the answer isn't 'in your bag', it doesn't make the shelf.",
  },
  {
    number: "02",
    title: "No Manual Needed",
    body: "If it needs an instruction booklet, it isn't easy enough. Our products unfold, click and stick exactly the way your hands already expect them to.",
  },
  {
    number: "03",
    title: "One Thing, Done Well",
    body: "We'd rather sell you one stand that folds flat than five that don't. Every item gets used daily, or it gets dropped from the catalogue.",
  },
];

const Chapter = ({ chapter, flip }) => {
  const words = chapter.title.split(" ");
  const lastWord = words.pop();

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-120px" }}
      transition={{ duration: 0.9, ease: EASE }}
      className={`relative ${flip ? "md:text-right" : ""}`}
    >
      <span
        aria-hidden="true"
        className={`pointer-events-none absolute -top-8 select-none font-serif text-[6.5rem] font-medium leading-none text-ember/10 sm:-top-12 sm:text-[9rem] md:-top-24 md:text-[16rem] ${
          flip ? "right-0" : "left-0"
        }`}
      >
        {chapter.number}
      </span>
      <div className="relative">
        <h3 className="font-serif text-3xl font-medium tracking-tight text-ink sm:text-5xl md:text-8xl">
          {words.join(" ")} <span className="italic text-ember">{lastWord}</span>
        </h3>
        <p
          className={`mt-4 max-w-xl text-base leading-relaxed text-smoke sm:mt-6 sm:text-lg md:text-xl ${
            flip ? "md:ml-auto" : ""
          }`}
        >
          {chapter.body}
        </p>
      </div>
    </motion.div>
  );
};

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="mx-auto max-w-[1600px] px-5 py-14 md:px-12 md:py-40"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-120px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="mb-14 md:mb-32"
      >
        <p className="text-xs uppercase tracking-[0.3em] text-smoke">
          The Manifesto
        </p>
        <h2 className="mt-4 font-serif text-5xl font-medium tracking-tight text-ink md:text-7xl">
          Three quiet <span className="italic text-ember">rules</span>.
        </h2>
      </motion.div>

      <div className="space-y-16 md:space-y-28">
        {CHAPTERS.map((chapter, i) => (
          <div key={chapter.number}>
            <Chapter chapter={chapter} flip={i % 2 === 1} />
            {i < CHAPTERS.length - 1 && (
              <motion.div
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 1.2, ease: EASE }}
                className="mt-12 h-px origin-left bg-line sm:mt-16 md:mt-28"
              />
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
